import { Component, input } from "@angular/core";
import { CurrencyPipe } from "@angular/common";
import { Card } from "primeng/card";
import { TPipe } from "../../i18n/t.pipe";
import { Quote } from "../../pricing/booking-quote";

@Component({
  standalone: true,
  selector: "app-price-breakdown",
  imports: [Card, CurrencyPipe, TPipe],
  template: `
    <p-card>
      @if (quote(); as q) {
        <div class="cost-row">
          <span>{{ "Prezzo camera" | t }}</span>
          <div>
            {{ q.roomPerNight | currency: "EUR" : "symbol" }} x {{ "{n} notti" | t: { n: q.nights } }}
            <strong>{{ q.roomTotal | currency: "EUR" : "symbol" }}</strong>
          </div>
        </div>
        <div class="cost-row">
          <span>{{ "Adulti extra" | t }}</span>
          <div>
            @if (q.extraAdults.count > 0) {
              {{ q.extraAdults.count }} x {{ q.extraAdults.perNight | currency: "EUR" : "symbol" }} {{ "/ notte" | t }} x {{ "{n} notti" | t: { n: q.nights } }}
              <strong>{{ q.extraAdults.total | currency: "EUR" : "symbol" }}</strong>
            } @else { 0 <small>({{ "{n} adulti inclusi" | t: { n: q.includedPersons } }})</small> }
          </div>
        </div>
        <div class="cost-row">
          <span>{{ "Bambini" | t }}</span>
          <div>
            @for (k of q.children; track k.index) {
              <div>{{ "Bambino {n} ({age} anni):" | t: { n: k.index, age: k.age } }} {{ k.perNight | currency: "EUR" : "symbol" }} {{ "/ notte" | t }}</div>
            } @empty { 0 }
            @if (q.children.length) {
              <strong>{{ q.childrenTotal | currency: "EUR" : "symbol" }}</strong>
            }
          </div>
        </div>
        <div class="cost-row">
          <span>{{ "Colazione" | t }}</span>
          <div>
            {{ "{n} ospiti" | t: { n: q.breakfastCount } }} x {{ "{n} notti" | t: { n: q.nights } }}
            <strong>{{ q.breakfastTotal | currency: "EUR" : "symbol" }}</strong>
          </div>
        </div>
        <div class="cost-row cost-total">
          <span>{{ "Prezzo totale" | t }}</span>
          <strong>{{ q.total === null ? "-" : (q.total | currency: "EUR" : "symbol") }}</strong>
        </div>
      } @else {
        <p>{{ "Seleziona date e camera per vedere i costi." | t }}</p>
      }
    </p-card>
  `,
  styles: [`
    .cost-row { display: grid; grid-template-columns: 8rem 1fr; gap: .5rem; padding: .5rem 0;
      border-bottom: 1px solid var(--p-surface-200, #e5e7eb); }
    .cost-row:last-child { border-bottom: 0; }
    .cost-row strong { margin-left: .35rem; }
    .cost-total { font-size: 1.1rem; }
  `],
})
export class PriceBreakdownComponent {
  readonly quote = input<Quote | null>(null);
}
